/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type IdVerificationUpdatedPayloadSideEffectType =
  (typeof IdVerificationUpdatedPayloadSideEffectType)[keyof typeof IdVerificationUpdatedPayloadSideEffectType];

export const IdVerificationUpdatedPayloadSideEffectType = {
  id_verification_updated: "id_verification_updated",
} as const;
